
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { useDescuentosStore } from "../../../store";
import { useDescuentosXTipo, useModales } from "../../../hooks";
import { DisenioLoteDistribuido } from "../../layout";
import { BusquedaSoloFecha, CargandoMedio, FBAFuncion, FormCreateDescuento, TablaDetalleDescuento, TarjetaResumenInfo } from "../../components";
import { ModalFormUno } from "../../components/components/ModalFormUno";
import { capitalizarPalabras, coloresTipo } from "../../../helpers";







export const DetallesDescuento = () => {


    const { id, descuento } = useParams();
    const { datosDescuento } = useDescuentosStore();
    const { handleAbrilModal, handleCerrarModal } = useModales();
    const { desucentoTipoQuery, page, chagePage, inicio, final, chageInicio, chageFinal } = useDescuentosXTipo({id, descuento});
    const palabra = capitalizarPalabras(descuento);

    

    return (

        <DisenioLoteDistribuido titulo={`Descuentos por ${palabra}`}>

            {desucentoTipoQuery.isLoading 
            ?   <CargandoMedio titulo="Cargando Información..." />
            :   <>
                <TarjetaResumenInfo data={datosDescuento} 
                    color={coloresTipo[descuento]} 
                    titulo={`Resumen ${palabra}`} 
                />
                {(desucentoTipoQuery?.data?.length > 0) 
                ?   <>
                        <BusquedaSoloFecha inicio={inicio} final={final} chageInicio={chageInicio} chageFinal={chageFinal} />
                        <TablaDetalleDescuento data={desucentoTipoQuery.data || []} chagePage={chagePage} page={page} />
                    </>
                :   <Box></Box>
                }
                </>
            }

            <FBAFuncion funcion={ handleAbrilModal } icono="plus" />
            <ModalFormUno titulo="Agregar Descuento" valor={{}} onClose={handleCerrarModal}>
                <FormCreateDescuento />
            </ModalFormUno>

        </DisenioLoteDistribuido>

    )
}
